import { createContext } from 'react';

/** Stable identity. Keep this file tiny so HMR of ProjectProvider does not replace the context. */
export const ProjectStateContext = createContext<unknown>(null);
